// Libraries
import { extendTheme } from '@chakra-ui/react';
import { ToastProviderProps } from '@chakra-ui/toast';
// Theme
import * as Components from '@themeComponents/index';
import {
  borders,
  colors,
  fontSizes,
  fonts,
  borderRadius as radii,
  shadows,
  sizes,
  space,
} from '@themeFoundations/index';

export const toastOptions: ToastProviderProps = {
  defaultOptions: {
    position: 'top',
    duration: 3000,
    variant: 'subtle',
    isClosable: true,
    containerStyle: {
      mt: 10,
    },
  },
};

const styles = {
  global: {
    ':not(.chakra-dont-set-collapse) > .chakra-collapse': {
      // Note: Important needed due chakra issue https://github.com/chakra-ui/chakra-ui/issues/2966#issuecomment-823028871
      overflow: 'initial !important',
    },
  },
};

// TODO: Add chakra docs to Docs folder
export const theme = extendTheme({
  styles,
  fonts,
  fontSizes,
  borders,
  colors,
  space,
  sizes,
  shadows,
  radii,
  components: { ...Components },
});

export default theme;
